export const getScrollPos = state => {
  return state.scrollPos
}

export const getActiveSectionName = state => {
  return state.activeSection
}

export const getAnimatingScrollState = state => {
  return state.isAnimatingScroll
}

export const getActiveSection = state => {
  return state.activeSection
}

export const getScrollLockState = state => {
  return state.scrollLocked
}

export const getNavItems = state => {
  return state.sections
}



// WEBPACK FOOTER //
// ./src/store/getters.js